import { parentNavigate } from "./ParentNavigate";

export function getInitialPage() {
  const urlParams = new URLSearchParams(window.location.search);
  const initialPage = parseInt(urlParams.get('page'));
  return initialPage ? initialPage : 1; // Adjust for zero-based indexing
}


export function replacePageInUrl(page) {
  const params = new URLSearchParams(window.location.search);
  if (page > 1) {
    params.set("page", page);
  } else {
    params.delete("page");
  }
  const newUrl =
    params.toString().length > 0
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;
  parentNavigate(newUrl);
  window.history.pushState({}, "", newUrl);
}
